import { render, staticRenderFns } from "./halfText2.vue?vue&type=template&id=78784f32&scoped=true"
import script from "./halfText2.vue?vue&type=script&lang=ts"
export * from "./halfText2.vue?vue&type=script&lang=ts"
import style0 from "./halfText2.vue?vue&type=style&index=0&id=78784f32&prod&scoped=true&lang=css"
import style1 from "./halfText2.vue?vue&type=style&index=1&id=78784f32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78784f32",
  null
  
)

export default component.exports